import React, {useEffect, useRef, useState} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {t,getLanguage} from 'react-switch-lang';
import {
  getAllRiskCategories,
  createRiskCategory,
  deleteRiskCategory,
  updateRiskCategory,
} from '../../../services/riskCategoriesService';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import AddIcon from './plus.png';
import './RiskCategories.scss';
import {validNameandNumberEngMneRegex} from '../../../utils/const';
import Swal from "sweetalert2";
const RiskCategories = () => {
  const [riskCategories, setRiskCategories] = useState([]);
  const [query, setQuery] = useState();

  const addButton = useRef();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllRiskCategories();
        setRiskCategories(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  const columns = [
    {
      dataIndex: 'name',
      title: t('riskCategories.name'),
      editable: true,
      placeholder: t('riskCategories.placeholder.name'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 255, message: t('message.max', {max: 255})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('riskCategories.nameEn'),
      editable: true,
      placeholder: t('riskCategories.placeholder.nameEn'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 255, message: t('message.max', {max: 255})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
  ];

  const onUpdate = async (data, editingRecord, form) => {
    data.id = editingRecord.id;
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await updateRiskCategory(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('riskCategories.message.updateSuccess', {
            entity: t('riskCategories.riskCategory'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('message.riskCategoryExists')],
          },
        ]);
      }
      if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('message.riskCategoryExists')],
          },
        ]);
      }
    }
  };

  const onCreate = async (data, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await createRiskCategory(data);
      if (response.status === 201) {
        Toast.fire({
          title: t('riskCategories.message.addSuccess', {
            entity: t('riskCategories.riskCategory'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('message.riskCategoryExists')],
          },
        ]);
      }
      if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('message.riskCategoryExists')],
          },
        ]);
      }
    }
  };

  const onDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteRiskCategory'),
        text: t('question.delete', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),

        confirmButtonText: t('common.delete').toUpperCase(),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            const response = await deleteRiskCategory(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('riskCategories.message.deleteSuccess', {
                  entity: t('riskCategories.riskCategory'),
                }),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: `${t('message.errorDeleteCategory')}`,
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
          }
        
      });
    });
  };

  return (
    <div className="riskCategories administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search-field">
          <SearchBox
            placeholder={t('riskCategories.placeholder.search')}
            setQuery={setQuery}
          />
        </div>
        <div className="button-add">
          <button className="btn btn-primary" ref={addButton}>
            <img src={AddIcon} alt="" />
            <p> {t('riskCategories.addCategory')}</p>
          </button>
        </div>
      </div>
      <CustomTable
        api="/risk-categories"
        query={query}
        queryParamName="name.contains"
        sort={getLanguage() === "eng" ? "nameEn" : "name"}
        columns={columns}
        methods={{onUpdate, onDelete, onCreate}}
        addButtonRef={addButton}
      />
    </div>
  );
};

export default RiskCategories;
